import React from 'react';
import { render } from 'react-dom';

import ContactFormApp from './contact-us-form/ContactFormApp';

const renderAppComponent = () => {
    const element = document.getElementById('contact-us-react-root');
    const recipient = JSON.parse(element.getAttribute('data-recipient'));

    render(
        <ContactFormApp recipient={recipient} />,
        document.getElementById('contact-us-react-root'),
    );
};

renderAppComponent();
